import { Organization, OrganizationName, OrganizationAddress, OrganizationLocation } from '../../domain/entities/Organization';
import { OrganizationRepository } from '../../domain/repositories/OrganizationRepository';

export class OrganizationRepositoryImpl implements OrganizationRepository {
  async getOrganization(): Promise<Organization> {
    // Dados baseados na referência
    return new Organization(
      { value: 'CASA DO PANDEIRO' } as OrganizationName,
      { value: 'TRAVESSA DO OUVIDOR, 36' } as OrganizationAddress,
      { value: 'CENTRO/RJ' } as OrganizationLocation
    );
  }
} 